import { useContext, useEffect, useMemo, useState } from "react"
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useRequestTypeMapping = () => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [requestTypeMapping, setRequestTypeMapping] = useState({});
    const [mappingList, setMappingList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filters, setFilters] = useState({});
    const [confirmationPopup, setConfirmationPopup] = useState({
        show: false,
        id: ""
    })
    const columnDefs = [
        {
            headerName: "User Name",
            field: "user_display_name",
            minWidth: 180,
            width: "30%",
        },
        {
            headerName: "Request Type",
            field: "request_type_name",
            minWidth: 180,
            width: "30%",
        },
        {
            headerName: "Action",
            field: "",
            minWidth: 100,
            width: "20%",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <FontAwesomeIcon
                        icon="fa-solid fa-trash"
                        className="remove"
                        onClick={() => setConfirmationPopup({ show: true, id: params?.data?.request_type_user_mapping_id })}
                    />
                )
            }
        },
    ]

    useEffect(() => {
        getRequestTypeUserMappingData()
    }, [])

    const getRequestTypeUserMappingData = async (type) => {
        try {
            setLoader(true)
            const payload = {
                "request_type_ids": _.pluck(filters.requestType || type, "request_type_id")?.toString() || ''
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTICKETREQUESTTYPEUSERMAPPING"), payload);
            if (!res?.body?.error_status) {
                setLoader(false)
                setMappingList(res?.body?.data?.ticket_request_type_user_mapping_details)
            }
        } catch (error) {
            setLoader(false)
            console.error("error::", error)
            showError('Error', error.response?.data?.errorMessage);
        }
    }

    const handleAddrequestType = async (e) => {
        try {
            e.preventDefault()
            if (!requestTypeMapping?.requestType?.request_type_id) {
                showInfo("info", "Please select request type");
                return;
            }
            if (!requestTypeMapping?.users || requestTypeMapping?.users?.length <= 0) {
                showInfo("info", "Please select Users");
                return;
            }
            const payload = {
                "request_type_id": requestTypeMapping?.requestType?.request_type_id,
                "requested_user_code": _.pluck(requestTypeMapping?.users, "user_code")?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVETICKETREQUESTTYPEUSERMAPPING"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setRequestTypeMapping({});
                getRequestTypeUserMappingData()
            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error::", error)
            showError('Error', error.response.data.errorMessage);
        }
    }

    const HandleDeleteMapping = async () => {
        try {
            const payload = {
                "request_type_user_mapping_id": confirmationPopup?.id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETETICKETREQUESTTYPEUSERMAPPING"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setConfirmationPopup({ show: false, id: "" })
                getRequestTypeUserMappingData()
            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error::", error)
            showError('Error', error.response.data.errorMessage);
        }
    }
    return useMemo(() => ({
        handleAddrequestType, requestTypeMapping, setRequestTypeMapping, columnDefs, mappingList, loader, getRequestTypeUserMappingData, filters, setFilters, HandleDeleteMapping, confirmationPopup, setConfirmationPopup
    }), [handleAddrequestType, requestTypeMapping, setRequestTypeMapping, columnDefs, mappingList, loader, getRequestTypeUserMappingData, filters, setFilters, HandleDeleteMapping, confirmationPopup, setConfirmationPopup])
}